module.exports = __webpack_public_path__ + "static/media/secured-payment.c355fd7c.svg";